import React from 'react';
import { FaFilePdf, FaCog } from 'react-icons/fa';
import './bank-statement.css';

const ProcessingLoader = ({ files = [], progress = { progress: 0, details: '' } }) => {
    return (
        <div className="bank-statement-card p-4 text-center">
            <div className="processing-animation mb-4">
                <div className="gear-icon one">
                    <FaCog />
                </div>
                <div className="gear-icon two">
                    <FaCog />
                </div>
                <div className="gear-icon three">
                    <FaCog />
                </div>
            </div>
            <h4 className="fw-bold text-dark mb-3">Analyzing Your Documents...</h4>
            
            <div className="progress" style={{ height: '20px', borderRadius: '10px', maxWidth: '80%', margin: '0 auto 1rem' }}>
                <div 
                    className="progress-bar progress-bar-striped progress-bar-animated" 
                    role="progressbar" 
                    style={{ width: `${progress.progress || 0}%` }} 
                    aria-valuenow={progress.progress || 0} 
                    aria-valuemin="0" 
                    aria-valuemax="100"
                >{progress.progress || 0}%</div>
            </div>
            <p className="text-muted small">
                {progress.details || 'Please wait while we use AI to extract and categorize your transactions...'}
            </p>

            {files.length > 0 && (
                <div className="mt-4 text-start w-75 mx-auto">
                    <h6 className="fw-bold text-secondary text-uppercase small mb-2">Files being processed:</h6>
                    {files.map((file, index) => (
                        <div key={index} className="d-flex align-items-center gap-2 p-2 bg-light rounded mb-2">
                            <FaFilePdf className="text-danger" />
                            <span className="fw-medium text-dark">{file.name}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProcessingLoader;